module.exports = require("npm:foreach@2.0.5/index.js");